import { useState, useEffect } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import NormalTable from "../../Component/NormalTable";
import { color } from "../../StyleData/Config";
import { masterAPI } from "../Masters/dataConfig";
import { axiosPrivate } from "../../axios/axios";
import { toUTC } from "../../utils/dateUtil";

const columns = [
  { Header: "Asset Code", accessor: "code" },
  { Header: "Asset Name", accessor: "assetName" },
  { Header: "Category", accessor: "categoryName" },
  { Header: "Asset Type", accessor: "assetTypeName" },
  { Header: "Location", accessor: "locationName" },
  { Header: "Status", accessor: "statusName" },
];

const TAB_STATUS = ["Active", "Stop"];

const AssetStatusDialog = ({ isDialogOpen, dateFrom, dateTo }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [listData, setListData] = useState([]);

  useEffect(() => {
    if (isDialogOpen) {
      axiosPrivate
        .post(`${masterAPI["KPIReport"].getAssetStatusList}`, {
          status: TAB_STATUS[activeTab],
          createdDateFrom: toUTC(dateFrom).utcISOString,
          createdDateTo: toUTC(dateTo).utcISOString,
        })
        .then((res) => setListData(res.data.result || []))
        .catch((e) => {
          console.log(e);
          setListData([]);
        });
    }
  }, [isDialogOpen, activeTab]);

  useEffect(() => {
    if (!isDialogOpen) {
      setActiveTab(0);
      setListData([]);
    }
  }, [isDialogOpen]);

  return (
    <>
      <Typography
        sx={{
          color: color.masterPageTitleColor,
          fontSize: color.masterPageTitleFontSize,
          fontWeight: color.masterPageTitleFontWeight,
          mb: color.masterPageTitlemd,
          px: 2,
          py: 1,
        }}
      >
        Asset Status
      </Typography>
      <Box sx={{ borderBottom: 1, borderColor: "divider", px: 2 }}>
        <Tabs
          value={activeTab}
          onChange={(e, val) => setActiveTab(val)}
        >
          <Tab label="Running" />
          <Tab label="Stop" />
        </Tabs>
      </Box>
      <Box sx={{ px: 2, py: 1 }}>
        {listData.length === 0 ? (
          <Typography
            sx={{
              textAlign: "center",
              color: "#999",
              fontSize: "14px",
              py: 4,
              fontFamily: "Nunito Sans, sans-serif",
            }}
          >
            No Data Available
          </Typography>
        ) : (
          <NormalTable data={listData} columns={columns} filt={true} />
        )}
      </Box>
    </>
  );
};

export default AssetStatusDialog;
